import React from "react";
import FmCard, {
  FmCardProps,
} from "domains/file-manager/components/FileManagerV2/FmCard";
import Button from "domains/ui/components/Button";

import { Text, VStack } from "@chakra-ui/react";

interface CardContainerProps extends Omit<FmCardProps<"canvas">, "type"> {}

export default React.memo(function CardContainer({
  children,
  ...props
}: CardContainerProps) {
  const file = props.file;

  return (
    <Button
      internalLink={{
        pathname: "/canvas/[id]",
        query: { id: file.id },
      }}
      variant="unstyled"
      _hover={{
        opacity: 0.8,
      }}
    >
      <VStack align="flex-start" spacing={2}>
        <FmCard type="canvas" {...props}>
          {children}
        </FmCard>

        <Text
          overflow="hidden"
          w="full"
          color="textPrimary"
          textAlign="center"
          isTruncated
          size="body.bold.md"
        >
          {file.meta.metadata.name || "Untitled"}
        </Text>
      </VStack>
    </Button>
  );
});
